import SectionLayout from "../../../layouts/SectionLayout";
import { ReactComponent as ArrowDiagonal } from "@images/arrow_diagonal.svg";
import { useState } from "react";
import { usePremium } from "@providers/PremiumContext";
import { PremiumSource } from "@models/Enums";
import { useAuth } from "@providers/AuthContext";
import DeleteUserModal from "../delete-user/DeleteUserModal";
import ChangeEmailModal from "../change-email/ChangeEmailModal";

const Account = () => {
	const [isShowChangeEmail, setIsShowChangeEmail] = useState<boolean>(false);
	const [isShowDeleteUser, setIsShowDeleteUser] = useState<boolean>(false);
	const { isPremium, premiumSource } = usePremium();
	const { authUser } = useAuth();

	const goToLink = (link: string) => {
		window.open(link, "_blank");
	};

	const goToStore = () => {
		var defaultLink = "https://pro.meco.app/p/login/28o03ichKg4jaRi9AA" + "?prefilled_email=" + encodeURIComponent(authUser!.email);

		switch (premiumSource) {
			case PremiumSource.appStore:
				defaultLink = "https://apps.apple.com/account/subscriptions";
				break;
			case PremiumSource.playStore:
				defaultLink = "https://play.google.com/store/account/subscriptions";
				break;
			default:
				break;
		}

		goToLink(defaultLink);
	};

	return (
		<>
			<ChangeEmailModal isShow={isShowChangeEmail} onClose={() => setIsShowChangeEmail(false)} />
			<DeleteUserModal isShow={isShowDeleteUser} onClose={() => setIsShowDeleteUser(false)} />
			<SectionLayout id="account" sectionTitle="Account">
				<div className="flex flex-row gap-4 flex-wrap">
					<button className="group flex items-center justify-between gap-4 bg-surface border hover:bg-surface-100 transition ease-in-out duration-300 border-primary-100 rounded-xl p-3 h-[60px] w-full" onClick={() => setIsShowChangeEmail(true)}>
						<div className="flex min-w-0 flex-grow">
							<div className="font-primary font-medium text-base text-primary text-left truncate">Change Email</div>
						</div>
					</button>
					{isPremium() && premiumSource && [PremiumSource.appStore, PremiumSource.stripe].includes(premiumSource) && (
						<button className="group flex items-center justify-between gap-4 bg-surface border hover:bg-surface-100 transition ease-in-out duration-300 border-primary-100 rounded-xl p-3 h-[60px] w-full" onClick={() => goToStore()}>
							<div className="flex min-w-0 flex-grow">
								<div className="font-primary font-medium text-base text-primary text-left truncate">Manage PRO Subscription</div>
							</div>
							<ArrowDiagonal className="fill-primary-500 group-hover:fill-primary w-[14px]" />
						</button>
					)}
					<button className="group flex items-center justify-between gap-4 bg-surface border hover:bg-surface-100 transition ease-in-out duration-300 border-primary-100 rounded-xl p-3 h-[60px] w-full" onClick={() => setIsShowDeleteUser(true)}>
						<div className="flex min-w-0 flex-grow">
							<div className="font-primary font-medium text-base text-brand-red text-left truncate">Delete Account</div>
						</div>
					</button>
				</div>
			</SectionLayout>
		</>
	);
};

export default Account;
